import { defineStore } from 'pinia'

// Exemplo de configuração básica do Pinia, biblioteca de gerenciamento de estado que o VueJs dá suporte
export const authStore = defineStore('auth', {
  state: () => {
    return {
      logged: false,
      user: null
    }
  },
  getters: {
    userName () {
      return this.userInfo.name
    },
    userInfo (state) {
      return {
        name: state.user?.username || ''
      }
    }
  },
  actions: {
    login (user) {
      this.logged = true
      this.user = user
    }
  }
})
